import MiniSearch from 'minisearch';

export default function docsSearch({ indexUrl, supportEmail }) {
    return {
        open: false,
        query: '',
        loading: false,
        mini: null,
        results: [],
        activeIndex: 0,
        indexUrl,
        supportEmail,

        get grouped() {
            const groups = new Map();

            this.results.forEach((item) => {
                if (!groups.has(item.docId)) {
                    groups.set(item.docId, {
                        id: item.docId,
                        title: item.title,
                        items: [],
                    });
                }

                groups.get(item.docId).items.push(item);
            });

            return Array.from(groups.values());
        },

        init() {
            window.addEventListener('keydown', (event) => {
                if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
                    event.preventDefault();
                    this.openPalette();
                }
            });

            window.addEventListener('docs-search-open', () => this.openPalette());

            this.$watch('query', () => this.search());
        },

        async openPalette() {
            this.open = true;
            this.activeIndex = 0;

            this.$nextTick(() => {
                this.$refs.searchInput?.focus();
            });

            await this.ensureLoaded();
        },

        closePalette() {
            this.open = false;
        },

        async ensureLoaded() {
            if (this.mini || this.loading) {
                return;
            }

            this.loading = true;

            try {
                const response = await fetch(this.indexUrl, {
                    headers: { Accept: 'application/json' },
                });

                if (!response.ok) {
                    throw new Error(`Docs index returned ${response.status}`);
                }

                const payload = await response.json();
                this.mini = new MiniSearch({
                    fields: ['title', 'heading', 'description', 'body'],
                    storeFields: ['doc_id', 'doc_type', 'doc_title', 'heading', 'category', 'url'],
                    searchOptions: {
                        prefix: true,
                        fuzzy: 0.2,
                        boost: {
                            title: 4,
                            heading: 3,
                            description: 2,
                            body: 1,
                        },
                    },
                });

                this.mini.addAll(payload.documents ?? []);
                this.search();
            } catch (error) {
                console.error(error);
                this.results = [];
            } finally {
                this.loading = false;
            }
        },

        search() {
            if (!this.mini || this.query.trim().length === 0) {
                this.results = [];
                this.activeIndex = 0;
                return;
            }

            this.results = this.mini
                .search(this.query.trim())
                .slice(0, 12)
                .map((result, index) => ({
                    id: result.id,
                    docId: result.doc_id,
                    title: result.doc_title,
                    heading: result.heading || result.doc_title,
                    category: result.category,
                    url: result.url,
                    index,
                }));

            this.activeIndex = Math.min(this.activeIndex, Math.max(this.results.length - 1, 0));
        },

        move(delta) {
            if (this.results.length === 0) {
                return;
            }

            this.activeIndex = (this.activeIndex + delta + this.results.length) % this.results.length;
        },

        choose() {
            if (this.results.length === 0) {
                return;
            }

            window.location.href = this.results[this.activeIndex].url;
        },
    };
}
